import { QUOTE_STEPS, ACTIONS, EXT_QUOTE_ACTIONS } from "../AppConstants";
import { IAppState } from "../state/interfaces";
import * as _ from 'lodash';

const initialState = {
    zipCode: "",
    coverageConfigCode: "",
    currentStep: QUOTE_STEPS.START,
    vehicles: [],
    drivers: [],
    currentInsurance: null,
    contactInfo: null,
    paymentChoice: null
}

interface IAction {
    type: string
}

export function rootReducer(state: IAppState | undefined, action: any) {
    if (typeof state === 'undefined') {
        return initialState;
    }

    switch (action.type) {
        case ACTIONS.QUOTE_STARTED:
            return { ...state, zipCode: action.zipCode, stateCode: action.stateCode }
        case ACTIONS.CHANGE_ZIP:
            const drivers = [...state.drivers];
            for (let i = 0; i < drivers.length; i++) {
                let driver = drivers[i];
                if (null !== driver.address) {
                    driver.address.city = action.city;
                    driver.address.stateCode = action.stateCode;
                    driver.address.zipCode = action.zipCode;
                    driver.address.street = "";
                }
            }
            return { ...state, zipCode: action.zipCode, stateCode: action.stateCode, drivers }
        case ACTIONS.QUOTE_STEP_CHANGED:
            return { ...state, currentStep: action.currentStep }
        case ACTIONS.QUOTE_CREATED:
            return action.quote.vehicle
                ? { ...state, quoteUid: action.quote.uid, quoteId: action.quote.quoteId, vehicles: [action.quote.vehicle] }
                : { ...state, quoteUid: action.quote.uid, quoteId: action.quote.quoteId }
        case ACTIONS.UPDATE_VEHICLE:
            for (let i = 0; i < state.vehicles.length; i++) {
                if (state.vehicles[i].id === action.vehicle.id) {
                    const updatedVehicle = Object.assign({}, state.vehicles[i], action.vehicle);
                    state.vehicles[i] = updatedVehicle;
                    return state;
                }
            }
            state.vehicles.push(action.vehicle);
            return state;
        case ACTIONS.UPDATE_DRIVER:
            for (let i = 0; i < state.drivers.length; i++) {
                if (state.drivers[i].id === action.driver.id) {
                    const updatedDriver = Object.assign({}, state.drivers[i], action.driver);
                    state.drivers[i] = updatedDriver;
                    if (0 === i && updatedDriver.address && updatedDriver.address.zipCode) {
                        state.zipCode = updatedDriver.address.zipCode;
                    }
                    return state;
                }
            }
            state.drivers.push(action.driver);
            return state;
        case ACTIONS.UPDATE_INSURANCE:
            state.currentInsurance = action.currentInsurance;
            return state;
        case ACTIONS.UPDATE_CONTACT_INFO:
            state.contactInfo = action.contactInfo;
            return state;
        case ACTIONS.SELECT_COVERAGE_CONFIG:
            return { ...state, coverageConfig: action.coverageConfig }
        case ACTIONS.PAYMENT_CHOICE_SELECTED:
            return { ...state, rate: action.rate, paymentChoice: action.paymentChoice }
        case ACTIONS.RTR_PAYMENT_CHOICE_SELECTED:
            return { ...state, rate: action.rate, paymentChoice: action.paymentChoice }
        case ACTIONS.LOAD_QUOTE:
            state.quoteUid = action.quote.uid;
            return { ...state, ...action.quote };
        case ACTIONS.FILL_EXTERNAL_QUOTE:
            console.log(action.quote);
            return { ...state, externalQuote: action.quote };
        case ACTIONS.FILL_RTR_QUOTE:
            console.log(action.quote);
            return {
                ...state,
                externalQuote: action.quote,
                paymentChoice: { ...state.paymentChoice, firstPay: action.paymentChoice.downpaymentAmount, regularPay: action.paymentChoice.installmentAmount }
            };
        case EXT_QUOTE_ACTIONS.UPDATE_VEHICLE:
            if (!state.externalQuote) return state;
            const vehicles = [...state.externalQuote.vehicles];
            
            for (let i = 0; i < vehicles.length; i++) {
                if (vehicles[i].id === action.vehicle.id) {
                    const updatedVehicle = Object.assign({}, vehicles[i], action.vehicle);
                    if (action.hasOwnProperty("vehicleChanged")) {
                        console.log("vehicleChanged");
                        updatedVehicle.changed = action.vehicleChanged;
                    }
                    vehicles[i] = updatedVehicle;
                    if (action.hasOwnProperty("quoteRerated")) {
                        console.log("rerated=" + action.quoteRerated);
                        return { ...state, externalQuote: { ...state.externalQuote, vehicles, reRated: action.quoteRerated } };
                    }
                    return { ...state, externalQuote: { ...state.externalQuote, vehicles } };
                }
            }
            return state;
        case EXT_QUOTE_ACTIONS.UPDATE_DRIVER:
            if (!state.externalQuote) return state;
            for (let i = 0; i < state.externalQuote.drivers.length; i++) {
                if (state.externalQuote.drivers[i].id === action.driver.id) {
                    const updatedDriver = Object.assign({}, state.externalQuote.drivers[i], action.driver);
                    state.externalQuote.drivers[i] = updatedDriver;
                    return state;
                }
            }
            return state;
        case EXT_QUOTE_ACTIONS.UPDATE_AGREEMENT:
            state.contactInfo = action.contactInfo;
            if (!state.externalQuote) return state;
            let { externalQuote } = { ...state };
            if (!externalQuote) return;
            externalQuote.agreement = action.agreement;
            return { ...state, externalQuote: externalQuote };
        case EXT_QUOTE_ACTIONS.RESET_AGREEMENT:
            if (!state.externalQuote) return state;

            state.externalQuote.agreement = {
                agreeDrivers: false,
                agreeEmailCorrect: false,
                agreeOtherDrivers: false,
                agreePolicyEffDate: false,
                agreeSalvage: false,
                agreeVehicles: false
            };

            return state;
        case EXT_QUOTE_ACTIONS.UPDATE_VIOLATIONS:
            if (!state.externalQuote) return state;
            return { ...state, externalQuote: { ...state.externalQuote, mvrResult: action.mvrResult, hasAdditionalDrivers: action.hasAdditionalDrivers } };
        case EXT_QUOTE_ACTIONS.UPDATE_ADDITIONAL_DRIVERS:
            if (!state.externalQuote) return state;
            return { ...state, externalQuote: { ...state.externalQuote, drivers: action.drivers, mvrResult: { ...state.externalQuote.mvrResult, additionalDrivers: action.additionalDrivers } } };
        case EXT_QUOTE_ACTIONS.RERATE_QUOTE:
            if (!state.externalQuote) return state;
            return {
                ...state,
                paymentChoice: { ...state.paymentChoice, firstPay: action.data.payment.downpaymentAmount, regularPay: action.data.payment.installmentAmount },
                externalQuote: { ...state.externalQuote, vehicles: action.data.quote.vehicles, reRated: true, hasMvrViolations: action.data.hasMvrViolations, hasAdditionalDrivers: action.data.hasAdditionalDrivers }
            };
        case EXT_QUOTE_ACTIONS.RESET_QUOTE_EFF_DATE:

            if (!state.externalQuote) return state;

            state.paymentChoice.firstPay = action.data.payment.downpaymentAmount;
            state.paymentChoice.regularPay = action.data.payment.installmentAmount;

            if (state.currentInsurance) {
                state.currentInsurance.effectiveDate = action.data.mappedQuote.effectiveDate;
            }

            state.externalQuote.effectiveDate = action.data.mappedQuote.effectiveDate;
            state.externalQuote.installmentDueDate = action.data.mappedQuote.installmentDueDate;
            state.externalQuote.reRated = true;

            return state;
        case EXT_QUOTE_ACTIONS.RELOAD_QUOTE_PMT_INFO:
            if (!state.externalQuote) return state;
            return {
                ...state,
                paymentChoice: { ...state.paymentChoice, firstPay: action.data.downpaymentAmount, regularPay: action.data.installmentAmount },
                externalQuote: { ...state.externalQuote, reRated: action.data.quoteRerated }
            };
        case EXT_QUOTE_ACTIONS.BIND_QUOTE:
            if (!state.externalQuote) return state;
            return {
                ...state,
                externalQuote: { ...state.externalQuote, bindResult: action.bindResult, esignatureForms: action.esignatureForms }
            };
        case EXT_QUOTE_ACTIONS.UPDATE_DOCUMENTS:
            if (!state.externalQuote) return state;
            return {
                ...state,
                externalQuote: {
                    ...state.externalQuote, bindResult: { ...state.externalQuote.bindResult, documents: action.documents }
                }
            };
        case EXT_QUOTE_ACTIONS.UPDATE_PAYMENT_PLAN:
            if (!state.externalQuote) return state;
            return {
                ...state,
                externalQuote: { ...state.externalQuote, paymentPlanCode: action.paymentPlanCode }
            };
        case EXT_QUOTE_ACTIONS.FILL_E_SIGNATURES:
            //if (!state.externalQuote) return state;
            const exQuote = state.externalQuote || {};
            const esignatureForms = _.sortBy(action.forms, ["displayOrder"]);
            return { ...state, externalQuote: { ...exQuote, esignatureForms: esignatureForms } };
        case ACTIONS.LOAD_CONTACT_INFO:
            state.contactInfo = action.contactInfo;
            return state;
        default:
            return state;
    }
}